// Safely get initial state from localStorage
const getInitialState = (key) => {
  try {
    const data = localStorage.getItem(key);
    if (data) {
      const parsedData = JSON.parse(data);
      return (Array.isArray(parsedData) && parsedData.length > 0) ? parsedData[0] : 0;
    }
    return 0;
  } catch (error) {
    console.warn(`Failed to parse ${key} from localStorage:`, error);
    return 0;
  }
};

let initialState = getInitialState("actmoredata");

const actmoredata = (state = initialState, action) => {

    switch(action.type){ 
      case "ACTMORE" : {
        const next = action.parm;
        // Do not keep plrforminfo cache on ACTMORE merges
        if (next && next !== 0 && typeof next === "object" && next.plrforminfo) {
          const { plrforminfo, ...rest } = next;
          return rest;
        }
        return next;
      }
      case "RESET": return initialState; //Always return the initial state
      default : return state;
  }
}

export default actmoredata